import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { DateInput, TimeInput, FormActions, Select, MultiSelect } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, submitSucceeded, t, onRecurranceTypeChange,
	recurrenceTypes, recurrenceType, initialValues, daysOfWeek, isReadonly }) => {

	const isWeekly = recurrenceType == 2;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<CentersDropdownList render='field' name='centerId' required horizontal label={t('IndividualConsultationSchedule_Center')} validate={[validators.required]} />
			<Select name='recurrenceType' required horizontal label={t('IndividualConsultationSchedule_RecurrenceType')} data={recurrenceTypes} validate={[validators.required]} onChange={onRecurranceTypeChange} />
			<DateInput name='startDate' label={isWeekly ? t('IndividualConsultationSchedule_StartDate') : t('IndividualConsultationSchedule_Date')}
				isReadonly={isReadonly} validators={validators.required} required horizontal />
			{isWeekly && <DateInput name='endDate' label={t('IndividualConsultationSchedule_EndDate')} isReadonly={isReadonly}
				validators={validators.required} required horizontal />}
			<TimeInput name='startTime' label={t('IndividualConsultationSchedule_StartTime')}
				validators={validators.required} required horizontal startTime={0} endTime={23} step={30} isReadonly={isReadonly}/>
			<TimeInput name='endTime' label={t('IndividualConsultationSchedule_EndTime')}
				validators={validators.required} required horizontal startTime={0} endTime={23} step={30} isReadonly={isReadonly}/>
			{isWeekly && <Field name='daysOfWeek' horizontal required component={MultiSelect} options={daysOfWeek} label={t('IndividualConsultationSchedule_DaysOfWeek')} validate={[validators.requiredArray]} />}
			<FormActions horizontal>
				<Link to='/individualConsultationsSchedule' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'individualConsultationsSchedule' })(withTranslation()(SettingsForm));
